import React from "react";
import { Card, CardBody } from "reactstrap";

import UserStateSummary from "./UserStateSummary";

const WizardSummaryHoc = (WrappedComponent) => {
  const WithSummary = (props) => {
    return (
      <div className="d-flex justify-content-between w-100 px-3">
        <Card style={{ margin: "1rem", width: "65%", height: "fit-content" }}>
          <CardBody>
            <WrappedComponent {...props} />
          </CardBody>
        </Card>

        <Card style={{ margin: "1rem", width: "30%" }}>
          <CardBody>
            <UserStateSummary />
          </CardBody>
        </Card>
      </div>
    );
  };

  return WithSummary;
};

export default WizardSummaryHoc;
